<script lang="ts">
	import { slide } from 'svelte/transition';
	import { createEventDispatcher } from 'svelte';
	import Optional from './Optional.svelte';

	export let label: string | undefined = undefined,
		name: string | undefined = label?.toLowerCase().replaceAll(' ', '_'),
		placeholder: string | undefined = undefined,
		error: string | undefined = undefined,
		value: string = '',
		optional: boolean = false,
		readOnly: boolean = false;

	const dispatch = createEventDispatcher();
</script>

<label class="label {$$props.class}">
	{#if label}
		<span class="flex items-center gap-1 font-medium">
			{label}
			{#if optional}
				<Optional />
			{/if}
		</span>
	{/if}

	<input
		type="text"
		{name}
		{placeholder}
		readonly={readOnly}
		class="input {error && '!border-error-500'}"
		bind:value
		on:change={(e) => {
			// FIXME: Value type
			// @ts-ignore
			dispatch('change', e.target?.value);
		}}
	/>
	{#if error}
		<span transition:slide|local class="text-error-500 !mt-0">{error}</span>
	{/if}
</label>
